import { collection, addDoc, updateDoc, doc, arrayUnion, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

// Yeni Destek Talebi / Soru (Müşteri tarafından)
export const createTicket = async (ticketData) => {
  try {
    const payload = {
      ...ticketData,
      status: 'open',                 // open, resolved
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };
    const docRef = await addDoc(collection(db, 'tickets'), payload);
    return docRef.id;
  } catch (error) {
    console.error("Ticket oluşturma hatası:", error);
    throw error;
  }
};

// Ticketa yeni mesaj ekleme (Müşteri veya Admin tarafından)
export const addMessageToTicket = async (ticketId, messageData) => {
  try {
    const ticketRef = doc(db, 'tickets', ticketId);
    await updateDoc(ticketRef, {
      messages: arrayUnion({
        ...messageData,
        createdAt: new Date().toISOString() // JSON serileştirilebilir zaman damgası
      }),
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error("Mesaja cevap verme hatası:", error);
    throw error;
  }
};

// Ticket durumunu güncelleme (Admin tarafından çözüldü vs)
export const updateTicketStatus = async (ticketId, newStatus) => {
  try {
    const ticketRef = doc(db, 'tickets', ticketId);
    await updateDoc(ticketRef, {
      status: newStatus,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error("Ticket durum güncelleme hatası:", error);
    throw error;
  }
};
